export interface DataIn {
    unlocked: null | boolean,
    open: null | boolean,
    lockedOut: null | boolean,
    forced: null | boolean,
    heldOpenWarning: null | boolean,
    heldOpenTooLong: null | boolean,
    breakglass: null | boolean,
    readerTamper: null | boolean,
    locked: null | boolean,
    closed: null | boolean,
    heldResponseMuted: null | boolean,
    //
    error: boolean,
    connencting: boolean,
    mode: 'binary' | 'toggle',
    timedUnlockTimeSecs: number,
}

export type DoorControlType = 'Lock'| 'Unlock'| 'Open'|'TimedUnlock'|'Lockout'|'Reinstate'|'ToggleLock'|'MuteHeldResponse'|'CancelAccessRequests';

export interface DataOut {
    doorControlType: DoorControlType, 
    doorControlData?: { 
        TimeSecs?: number 
    }
}